<template>
  <div class="modal fade show d-block" tabindex="-1" role="dialog" aria-modal="true">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">
      <form class="modal-content" @submit.prevent="submit">
        <div class="modal-header">
          <h5 class="modal-title">Editar Booking Form</h5>
        </div>
        <div class="modal-body">
          <section class="py-3 border-bottom">
            <div class="d-flex align-items-center justify-content-between mb-3"><h6 class="mb-0 font-weight-bold">Contacto</h6><button type="button" class="btn btn-sm btn-outline-danger" @click="removeContact = !removeContact">{{ removeContact ? 'Deshacer' : 'Eliminar módulo' }}</button></div>
            <div v-if="!removeContact" class="row">
              <label v-for="field in contactFields" :key="field.key" class="col-md-4 mb-3 small text-muted">{{ field.label }}<input class="form-control" v-model="contact[field.key]"></label>
            </div>
          </section>

          <section v-if="passengers.length" class="py-3 border-bottom">
            <div class="d-flex align-items-center justify-content-between mb-3"><h6 class="mb-0 font-weight-bold">Pasajeros</h6><button type="button" class="btn btn-sm btn-outline-danger" @click="toggleAllPassengers">{{ allPassengersRemoved ? 'Deshacer' : 'Eliminar módulo' }}</button></div>
            <div v-for="(pax, index) in visiblePassengers" :key="pax.id" class="card bg-light mb-3">
              <div class="card-body">
              <div class="d-flex align-items-center justify-content-between mb-3"><strong>{{ passengerLabel(pax, index) }}</strong><button type="button" class="btn btn-sm btn-link text-danger" @click="removedPassengerIds.push(pax.id)">Eliminar</button></div>
              <div class="row">
                <label v-for="field in passengerFields" :key="field.key" class="col-md-4 mb-3 small text-muted">{{ field.label }}<input class="form-control" v-model="pax[field.key]"></label>
              </div>
              </div>
            </div>
          </section>

          <section v-if="flights.length" class="py-3 border-bottom">
            <div class="d-flex align-items-center justify-content-between mb-3"><h6 class="mb-0 font-weight-bold">Vuelos generales</h6><button type="button" class="btn btn-sm btn-outline-danger" @click="removeFlights = !removeFlights">{{ removeFlights ? 'Deshacer' : 'Eliminar módulo' }}</button></div>
            <template v-if="!removeFlights">
              <div v-for="(flight, index) in visibleFlights" :key="flight.id" class="card bg-light mb-3">
                <div class="card-body"><div class="d-flex align-items-center justify-content-between mb-3"><strong>Vuelo {{ index + 1 }}</strong><button type="button" class="btn btn-sm btn-link text-danger" @click="removedFlightIds.push(flight.id)">Eliminar</button></div>
                <div class="row"><label v-for="field in flightFields" :key="field.key" class="col-md-4 mb-3 small text-muted">{{ field.label }}<input class="form-control" v-model="flight[field.key]"></label></div></div>
              </div>
            </template>
          </section>

          <section v-if="rooms.length" class="py-3 border-bottom">
            <div class="d-flex align-items-center justify-content-between mb-3"><h6 class="mb-0 font-weight-bold">Habitaciones</h6><button type="button" class="btn btn-sm btn-outline-danger" @click="removeRooms = !removeRooms">{{ removeRooms ? 'Deshacer' : 'Eliminar módulo' }}</button></div>
            <template v-if="!removeRooms">
              <div v-for="(room, index) in visibleRooms" :key="room.id" class="card bg-light mb-3">
                <div class="card-body"><div class="d-flex align-items-center justify-content-between mb-3"><strong>Habitación {{ index + 1 }}</strong><button type="button" class="btn btn-sm btn-link text-danger" @click="removedRoomIds.push(room.id)">Eliminar</button></div>
                <div class="row"><label class="col-md-4 mb-3 small text-muted">Tipo<input class="form-control" v-model="room.Type"></label><label class="col-md-8 mb-3 small text-muted">Nombres<input class="form-control" v-model="room.Names"></label></div></div>
              </div>
            </template>
          </section>

          <section class="py-3 border-bottom">
            <div class="d-flex align-items-center justify-content-between mb-3"><h6 class="mb-0 font-weight-bold">Preferencias de hotel</h6><button v-if="hotelPreferences" type="button" class="btn btn-sm btn-link text-danger" @click="hotelPreferences = ''">Eliminar</button></div>
            <textarea class="form-control" rows="2" v-model="hotelPreferences"></textarea>
          </section>

          <section v-if="attachments.length" class="py-3">
            <div class="d-flex align-items-center justify-content-between mb-3"><h6 class="mb-0 font-weight-bold">Adjuntos</h6><button type="button" class="btn btn-sm btn-outline-danger" @click="removeAttachments = !removeAttachments">{{ removeAttachments ? 'Deshacer' : 'Eliminar módulo' }}</button></div>
            <span v-for="file in visibleAttachments" :key="file.key" class="badge badge-light mr-2 mb-2 p-2">{{ file.file_name }} <button type="button" class="btn btn-sm btn-link text-danger p-0 ml-1" @click="removedAttachmentKeys.push(file.key)">&times;</button></span>
          </section>

        </div>
        <div class="modal-footer"><button type="button" class="btn btn-secondary" :disabled="saving" @click="$emit('close')">Cancelar</button><button class="btn btn-primary" :disabled="saving">{{ saving ? 'Guardando…' : 'Guardar' }}</button></div>
      </form>
    </div>
  </div>
  <div class="modal-backdrop fade show"></div>
</template>

<script>
export default {
  name: 'BookingFormEditModal',
  props: { booking: { type: Object, required: true }, attachments: { type: Array, default: () => [] }, saving: Boolean },
  data() {
    return {
      contact: {}, passengers: [], flights: [], rooms: [], hotelPreferences: '',
      removeContact: false, removeFlights: false, removeRooms: false, removeAttachments: false,
      removedPassengerIds: [], removedFlightIds: [], removedRoomIds: [], removedAttachmentKeys: [],
      contactFields: [
        { key: 'PaxName', label: 'Nombre' }, { key: 'Address', label: 'Dirección' }, { key: 'ZipCode', label: 'Código postal' },
        { key: 'Nationality', label: 'Nacionalidad' }, { key: 'Mobile', label: 'Teléfono' }, { key: 'Email', label: 'Email' },
        { key: 'EmergencyContactFullName', label: 'Contacto de emergencia' }, { key: 'EmergencyContactRelationship', label: 'Relación' },
        { key: 'EmergencyContactPrimaryPhone', label: 'Teléfono principal' }, { key: 'EmergencyContactSecondaryPhone', label: 'Teléfono secundario' },
        { key: 'EmergencyContactEmail', label: 'Email de emergencia' }
      ],
      passengerFields: [
        { key: 'Selected', label: 'Pasajero' }, { key: 'FirstName', label: 'Nombre' }, { key: 'MiddleName', label: 'Segundo nombre' },
        { key: 'LastName', label: 'Apellido' }, { key: 'DOB', label: 'Nacimiento' }, { key: 'Gender', label: 'Género' },
        { key: 'Nationality', label: 'Nacionalidad' }, { key: 'Passport', label: 'Pasaporte' }, { key: 'PassportExpirationDate', label: 'Vencimiento' },
        { key: 'Email', label: 'Email' }, { key: 'Mobile', label: 'Teléfono' }, { key: 'EmergencyContact', label: 'Contacto de emergencia' },
        { key: 'Allergies', label: 'Alergias' }, { key: 'FoodRestriction', label: 'Restricciones alimentarias' },
        { key: 'MedicalConditionsMedications', label: 'Condiciones / medicación' }, { key: 'SharingRoomWith', label: 'Comparte habitación con' },
        { key: 'TypeOfBedding', label: 'Tipo de cama' }, { key: 'InsuranceCompany', label: 'Seguro' },
        { key: 'InsurancePolicyNumber', label: 'Póliza' }, { key: 'InsuranceEmergencyPhone', label: 'Teléfono del seguro' }
      ],
      flightFields: [
        { key: 'Airline', label: 'Aerolínea' }, { key: 'FlightNumber', label: 'Vuelo' }, { key: 'ReservationCode', label: 'Reserva' },
        { key: 'DepartureDate', label: 'Fecha salida' }, { key: 'DepartureTime', label: 'Hora salida' }, { key: 'DepartureCity', label: 'Origen' },
        { key: 'ArrivalDate', label: 'Fecha llegada' }, { key: 'ArrivalTime', label: 'Hora llegada' }, { key: 'ArrivalCity', label: 'Destino' }
      ]
    };
  },
  computed: {
    visiblePassengers() { return this.passengers.filter(pax => !this.removedPassengerIds.includes(pax.id)); },
    visibleFlights() { return this.flights.filter(item => !this.removedFlightIds.includes(item.id)); },
    visibleRooms() { return this.rooms.filter(item => !this.removedRoomIds.includes(item.id)); },
    visibleAttachments() { return this.removeAttachments ? [] : this.attachments.filter(item => !this.removedAttachmentKeys.includes(item.key)); },
    allPassengersRemoved() { return this.passengers.length > 0 && this.visiblePassengers.length === 0; }
  },
  created() {
    this.contact = this.contactFields.reduce((values, field) => {
      values[field.key] = this.booking[field.key] || '';
      return values;
    }, {});
    this.passengers = JSON.parse(JSON.stringify(this.booking.BookingFormPaxs || []));
    this.flights = JSON.parse(JSON.stringify(this.booking.BookingFormFlights || []));
    this.rooms = JSON.parse(JSON.stringify(this.booking.BookingFormRooms || []));
    this.hotelPreferences = this.booking.SuggestedHotels || '';
  },
  methods: {
    passengerLabel(pax, index) { return pax.Selected || [pax.FirstName, pax.MiddleName, pax.LastName].filter(Boolean).join(' ') || `Pasajero ${index + 1}`; },
    toggleAllPassengers() { this.removedPassengerIds = this.allPassengersRemoved ? [] : this.passengers.map(pax => pax.id); },
    submit() {
      if (this.saving) return;
      this.$emit('save', {
        contact: this.removeContact, passengerIds: this.removedPassengerIds,
        flights: this.removeFlights, rooms: this.removeRooms, hotelPreferences: false, attachments: this.removeAttachments,
        flightIds: this.removedFlightIds, roomIds: this.removedRoomIds, attachmentKeys: this.removedAttachmentKeys,
        updates: { contact: this.contact, passengers: this.visiblePassengers, flights: this.visibleFlights, rooms: this.visibleRooms, hotelPreferences: this.hotelPreferences }
      });
    }
  }
};
</script>
